import Multiselect from '@rio-cloud/rio-uikit/Multiselect';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import type { FleetGroup } from '#domain/FleetGroup.ts';

type FleetGroupFilterProps = {
    fleetGroups: FleetGroup[];
    value: string[];
    onChange: (value: string[]) => void;
    isLoading?: boolean;
    disabled?: boolean;
    className?: string;
    compact?: boolean;
};

export const FleetGroupFilter = ({
    fleetGroups,
    value,
    onChange,
    isLoading,
    disabled,
    className = 'min-width-250',
    compact = false,
}: FleetGroupFilterProps) => {
    const intl = useIntl();
    const options = useMemo(
        () =>
            [...fleetGroups]
                .sort((first, second) => first.name.localeCompare(second.name))
                .map(group => ({ id: group.id, label: group.name, selected: value.includes(group.id) })),
        [fleetGroups, value]
    );
    const message = (key: string) =>
        intl.formatMessage({ id: `intl-msg:ordercom-cloud-frontend.tours.filter.groups.${key}` });

    return (
        <Multiselect
            onChange={onChange}
            options={options}
            value={value}
            placeholder={message('placeholder')}
            noItemMessage={message('no-groups-found')}
            counterMessage={{ one: message('counter.one'), many: message('counter.many') }}
            renderCounterMessage={
                compact
                    ? count => {
                          const label = `${message('placeholder')} (${intl.formatNumber(count)})`;
                          return <span title={label}>{label}</span>;
                      }
                    : undefined
            }
            className={className}
            isLoading={isLoading}
            disabled={disabled}
            useFilter
        />
    );
};
